function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, ChangeEventHandler, MouseEventHandler, KeyboardEventHandler, FocusEventHandler, InputHTMLAttributes } from 'react';
import cn from 'classnames';
require("./TextInput-Control.css");
var styles = {
  "Root": "TextInput-Control-module-Root_2iJ",
  "disabled": "TextInput-Control-module-disabled_2_6"
};
export const TextInputControl = ({
  autoComplete = 'off',
  autoFocus,
  className,
  controlRef,
  defaultValue,
  disabled,
  id,
  inputMode,
  max,
  maxLength,
  min,
  name,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  onKeyPress,
  onKeyUp,
  pattern,
  placeholder,
  readOnly,
  required,
  tabIndex,
  type,
  value,
  ...props
}) => /*#__PURE__*/React.createElement("input", _extends({}, props, {
  autoComplete: autoComplete,
  autoFocus: autoFocus,
  className: cn(styles.Root, {
    [styles.disabled]: disabled
  }, className)
  // @ts-ignore
  ,
  defaultValue: defaultValue,
  disabled: disabled,
  id: id,
  inputMode: inputMode,
  max: max,
  maxLength: maxLength,
  min: min,
  name: name,
  onBlur: onBlur,
  onChange: onChange,
  onFocus: onFocus,
  onKeyDown: onKeyDown,
  onKeyPress: onKeyPress,
  onKeyUp: onKeyUp,
  pattern: pattern,
  placeholder: placeholder,
  readOnly: readOnly,
  ref: controlRef,
  required: required,
  tabIndex: tabIndex,
  type: type,
  value: value
}));